import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const PUT_COMPANY_REQUEST_FILE = "PUT_COMPANY_REQUEST_FILE";
export const PUT_COMPANY_SUCCESS_FILE = "PUT_COMPANY_SUCCESS_FILE";
export const PUT_COMPANY_ERROR_FILE = "PUT_COMPANY_ERROR_FILE";

//* ACTIONS ------------------------------------------------
export const putCompanyRequestFile = (payload = {}, callback) => ({
  type: PUT_COMPANY_REQUEST_FILE,
  payload,
  callback,
});

export const putCompanySuccessFile = () => ({
  type: PUT_COMPANY_SUCCESS_FILE,
});

export const putCompanyErrorFile = (error) => ({
  type: PUT_COMPANY_ERROR_FILE,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const putCompanyServiceRequestFile = async ({ companyId, formD }) => {
  const options = await withToken({
    method: Methods.POST,
    headers: { CompanyId: await getUserCompany() },
    data: formD,
  });

  return request(`/companies/${companyId}/logo`, options);
};
